import {v4 as uuidv4} from 'uuid';

import type {DosageDetails} from '@/services/graphqlHooks';

import type {DosageDetailsWithId} from './medicationTypes';

export const addDosage = (
  dosage: DosageDetails,
  dosages: DosageDetailsWithId[] = []
): DosageDetailsWithId[] => {
  return [...dosages, {...dosage, id: uuidv4()}];
};

export const updateDosage = (
  dosage: DosageDetailsWithId,
  dosages: DosageDetailsWithId[] = []
): DosageDetailsWithId[] => {
  return dosages.map(item =>
    item.id === dosage.id ? {...item, ...dosage} : item
  );
};

export const removeDosage = (
  id: string,
  dosages: DosageDetailsWithId[] = []
): DosageDetailsWithId[] => {
  return dosages.filter(dosage => dosage.id !== id);
};

export const findDosage = (
  id: string,
  dosages: DosageDetailsWithId[] = []
): DosageDetailsWithId | undefined => {
  return dosages.find(dosage => dosage.id === id);
};
